import { Regex } from './Regex'

/**
 */
const PASSWORD_PATTERN = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,}$/

/**
 */
export const Password = Regex(PASSWORD_PATTERN)
